var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mb10" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit:remove",
                  value: "btn:payable:quoteManagement:addEdit",
                  expression: "'btn:payable:quoteManagement:addEdit'",
                  arg: "remove",
                },
              ],
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v(" " + _vm._s(_vm.$t("basicData.AddARow")) + " ")]
          ),
        ],
        1
      ),
      _c("table-cmp", {
        ref: _vm.currentTableRef,
        attrs: { "table-data": _vm.currentTableData },
        on: { change: _vm.handleTableChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }